import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wheel-campaign__main" }
const _hoisted_2 = { class: "wheel-campaign__main-upper" }
const _hoisted_3 = { class: "wheel-campaign__main-note" }
const _hoisted_4 = { class: "wheel-campaign__main-note-about" }
const _hoisted_5 = { class: "wheel-campaign__main-note-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "wheel-campaign__main-note-goal" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "wheel-campaign__progress-collected" }
const _hoisted_11 = { class: "wheel-campaign__progress-num" }
const _hoisted_12 = { class: "wheel-campaign__progress-bar" }
const _hoisted_13 = { class: "wheel-campaign__side" }
const _hoisted_14 = { class: "wheel-campaign__side-note" }
const _hoisted_15 = { class: "wheel-campaign__side-note-card" }
const _hoisted_16 = { class: "wheel-campaign__side-completed" }
const _hoisted_17 = { class: "wheel-campaign__thanks-note" }

import { computed, reactive, ref, nextTick } from "vue";
import gsap from "gsap";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsSmileStatic from "@sazka/design-system/src/smiles//ds-smile-static.vue";
import MobileAppLink from "@sazka/mobile-apps/components/mobile-app-link.vue";
import {
    DsSmileStaticFacePosition as FacePosition,
    DsSmileStaticFaceType as FaceType,
} from "@sazka/design-system/src/smiles//ds-smile-static-types";
import { getActiveWheelCampaign } from "@sazka/utils/api/wheel-campaign-api";
import { WheelCampaign } from "@sazka/utils/models/wheel-campaign";
import { StringUtils } from "@sazka/utils/string-utils";
import { onViewportEnter } from "@sazka/utils/viewport-enter";
import {
    dataLayerCharityBannerImpression,
    dataLayerCharityBannerClickMoreInfo,
    dataLayerCharityBannerClickSpinWheel,
} from "./wof-analytics";

const animationDuration = 1.6;
const bannerPosition = "middle";


export default /*@__PURE__*/_defineComponent({
  __name: '_wof-campaign',
  setup(__props) {

const wheelCampaignRef = ref(null);
const campaignInfo = ref<WheelCampaign>(null);
const isCollectedSumInViewport = ref(false);
const collectedSumInfoRef = ref<HTMLElement>(null);
const snap = gsap.utils.snap(1);

const tweenedSum = reactive({
    number: 0,
});
const tweenedProgress = reactive({
    number: 0,
});

const progressBarStyle = computed(() => "width: " + tweenedProgress.number + "%");
const goalProgressPercentage = computed(() => {
    if (!campaignInfo.value || campaignInfo.value.currentValue == 0 || campaignInfo.value.targetValue == 0) return 0;
    if (campaignInfo.value.currentValue / campaignInfo.value.targetValue >= 1) return 100;
    return (100 * campaignInfo.value.currentValue) / campaignInfo.value.targetValue;
});
const isGoalCompleted = computed(() => goalProgressPercentage.value >= 100);
const goalSumFormatted = computed(() => StringUtils.toCurrencyString(campaignInfo.value.targetValue));
const collectedSumFormatted = computed(
    () => StringUtils.toCurrencyString(snap(tweenedSum.number)) + (isGoalCompleted.value ? "!" : "")
);
const promoText1 = computed(() =>
    isGoalCompleted.value ? "Úžasné! Pomohli jste nám vybrat" : campaignInfo.value?.texts?.promoText1
);
const faceType = computed(() => (isGoalCompleted.value ? FaceType.Stars : FaceType.Hearts));
const spinWheelButtonText = ref("Zatočit Kolem Štěstí");

const getBannerTextForDataLayer = () =>
    campaignInfo.value?.texts.wheelPromoText1 + " " + campaignInfo.value?.texts.wheelPromoText2;

const moreInfoClick = () => {
    dataLayerCharityBannerClickMoreInfo();
};

const spinWheelClick = () => {
    dataLayerCharityBannerClickSpinWheel(campaignInfo.value.id.toString(), spinWheelButtonText.value, bannerPosition);
};

const setupActiveCampaign = async () => {
    try {
        campaignInfo.value = await getActiveWheelCampaign();
    } catch (error) {
        console.log("activeCampaign", error);
    }

    if (campaignInfo.value) {
        nextTick(() => {
            const hash = window.location.hash.substring(1);
            if (hash == "dobrokolo") {
                wheelCampaignRef.value.scrollIntoView(true);
            }

            onViewportEnter(collectedSumInfoRef.value).then(() => {
                isCollectedSumInViewport.value = true;
                gsap.to(tweenedSum, { duration: animationDuration, number: campaignInfo.value.currentValue ?? 0 });
                gsap.to(tweenedProgress, { duration: animationDuration, number: goalProgressPercentage.value });

                dataLayerCharityBannerImpression(
                    campaignInfo.value.id.toString(),
                    getBannerTextForDataLayer(),
                    bannerPosition
                );
            });
        });
    }
};

setupActiveCampaign();

return (_ctx: any,_cache: any) => {
  return (campaignInfo.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "wheel-campaign",
        ref_key: "wheelCampaignRef",
        ref: wheelCampaignRef
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DsSmileStatic, {
                faceType: faceType.value,
                facePosition: _unref(FacePosition).RightDown,
                responsive: false,
                class: "wheel-campaign__main-note-smile"
              }, null, 8, ["faceType", "facePosition"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", { innerHTML: promoText1.value }, null, 8, _hoisted_6),
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(goalSumFormatted.value), 1),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _createElementVNode("span", {
                    innerHTML: campaignInfo.value.texts?.promoText2
                  }, null, 8, _hoisted_8),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  _createElementVNode("span", {
                    class: "wheel-campaign__main-note-bold",
                    innerHTML: campaignInfo.value.texts?.promoText3
                  }, null, 8, _hoisted_9),
                  _cache[5] || (_cache[5] = _createTextVNode(". "))
                ]),
                _createVNode(MobileAppLink, {
                  href: campaignInfo.value.texts?.promoLink,
                  openInNewTab: true,
                  class: "wheel-campaign__main-note-link",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (moreInfoClick()))
                }, {
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createTextVNode(" Více informací ")),
                    _createVNode(DsIcon, {
                      name: "help-thin",
                      swapBreakpoint: "sm2"
                    })
                  ]),
                  _: 1,
                  __: [6]
                }, 8, ["href"])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "wheel-campaign__main-lower",
            ref_key: "collectedSumInfoRef",
            ref: collectedSumInfoRef
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "wheel-campaign__progress-text" }, " Již jsme vybrali ", -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(collectedSumFormatted.value), 1)
            ], 512), [
              [_vShow, isCollectedSumInViewport.value]
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "wheel-campaign__progress-fill",
                style: _normalizeStyle(progressBarStyle.value)
              }, null, 4)
            ])
          ], 512)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(WebpImage, {
                class: "wheel-campaign__side-note-coin",
                src: "/frontend/kasa-loyalty/img/widgets/wheel-campaign/Coin.png",
                alt: "zlatá mince"
              }),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "wheel-campaign__side-note-text" }, "Za každé vaše zatočení věnuje Sazka 1 Kč.", -1))
            ]),
            _createVNode(MobileAppLink, {
              href: "/sazka-klub/zatocte-si-kolem",
              class: "wheel-campaign__side-note-link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (spinWheelClick()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(spinWheelButtonText.value) + " ", 1),
                _createVNode(DsIcon, {
                  name: "arrow-right-thin",
                  swapBreakpoint: "md"
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(WebpImage, {
            class: "wheel-campaign__side-wheel",
            src: "/frontend/kasa-loyalty/img/widgets/wheel-campaign/campaign-wheel.png",
            alt: "kolo štěstí"
          })
        ], 512), [
          [_vShow, !isGoalCompleted.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "wheel-campaign__thanks-note-text" }, "Děkujeme! ", -1)),
            _createVNode(WebpImage, {
              class: "wheel-campaign__thanks-note-heart",
              src: "/frontend/kasa-loyalty/img/widgets/wheel-campaign/Heart.png",
              alt: "emoji srdce"
            })
          ])
        ], 512), [
          [_vShow, isGoalCompleted.value]
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})